import axios from "axios";

const origin = process.env.VUE_APP_API_ORIGIN || window.location.origin;
const host = `${origin}/api/v1`;

export const request = async (method = "GET", url, data) => {
  let options = { method, url, withCredentials: true };
  if (data) {
    options["headers"] = { "Content-Type": "application/json" };
    options["data"] = data;
  }
  let res = await axios(options);
  return res.data;
};

export const logout = () => {
  let url = buildURL({ type: "session" });
  return axios({
    url,
    method: "DELETE",
    withCredentials: true
  });
};

const buildQueryString = queryObject => {
  var queryString = "";
  for (let key in queryObject) {
    queryString += queryString ? "&" : "?";
    queryString += `${key}=${queryObject[key]}`;
  }
  return queryString;
};

export const buildURL = ({ parent, type, id, query }) => {
  let url = parent ? buildURL(parent) : host;
  type && (url += `/${type}`);
  id && (url += `/${id}`);
  query && (url += buildQueryString(query));
  return url;
};
